// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__18AMb","content":"Consent_content__1V2k0","footer":"Consent_footer__sRfXa"};